import { useRef } from "react"

export type ItemsLiveAddedAt = Map<string, Date>

const MAX_SIZE = 100

export function useItemsLiveAddedAt() {
  const itemsLiveAddedAtRef = useRef<ItemsLiveAddedAt>(new Map())

  function populateItemsLiveAddedAt(newItemIds: string[]) {
    const itemsLiveAddedAt = itemsLiveAddedAtRef.current

    newItemIds.forEach(id => {
      if (!itemsLiveAddedAt.has(id)) {
        itemsLiveAddedAt.set(id, new Date())
      }
    })

    // Remove oldest items if size exceeds MAX_SIZE
    while (itemsLiveAddedAt.size > MAX_SIZE) {
      const oldestKey = itemsLiveAddedAt.keys().next().value
      if (oldestKey) {
        itemsLiveAddedAt.delete(oldestKey)
      }
    }

    return itemsLiveAddedAt
  }

  return populateItemsLiveAddedAt
}
